export const apiConstants = {
  url: "/api/option"
};
